import React, { Component } from 'react';

// Styles
import './style.css'

// Components
import Form from '../home/contato/index'

export default class FaleConosco extends Component {
    render() {
        return(  
                < Form />
        )
    }
}

